/**
 * API service para criterios de inclusión residencial — V1.6
 */

import type {
  ResidentialCriteriaResponse,
  ResidentialCriteriaPreview,
  PatchResidentialCriteriaDto,
} from './building-residential-criteria.types';

const BASE = '/api/v1';

async function request<T>(
  path: string,
  options?: RequestInit,
): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    ...options,
  });
  if (!res.ok) {
    const body = await res.text().catch(() => '');
    throw new Error(`${res.status} ${res.statusText}${body ? ` — ${body}` : ''}`);
  }
  return res.json() as Promise<T>;
}

export const residentialCriteriaApi = {
  /**
   * GET /projects/:projectId/buildings/residential-criteria
   * Retorna criterios actuales (o defaults si nunca se configuraron).
   */
  getCriteria(projectId: string): Promise<ResidentialCriteriaResponse> {
    return request(`/projects/${projectId}/buildings/residential-criteria`);
  },

  /**
   * PATCH /projects/:projectId/buildings/residential-criteria
   * Merge parcial de criterios.
   */
  patchCriteria(projectId: string, dto: PatchResidentialCriteriaDto): Promise<ResidentialCriteriaResponse> {
    return request(`/projects/${projectId}/buildings/residential-criteria`, {
      method: 'PATCH',
      body: JSON.stringify(dto),
    });
  },

  /**
   * GET /projects/:projectId/buildings/residential-criteria/preview
   * Retorna conteos de elegibilidad bajo criterios actuales.
   */
  getPreview(projectId: string): Promise<ResidentialCriteriaPreview> {
    return request(`/projects/${projectId}/buildings/residential-criteria/preview`);
  },
};
